import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  RedeemExchange as RedeemExchangeComponent,
  RedeemExchangeProps,
} from "../../components/RedeemExchange/RedeemExchange";
import { StoreState } from "../../reducers";
import {
  getExchangeId,
  getExchanges,
  getWidgetConfig,
} from "../../reducers/methods";
import {
  exchangeRedeem,
  ExchangeRedeemParams,
  getExchangesAction,
  rewardStoreExchangeRedeem,
  setScreenName,
} from "../../actions";

interface RedeemExchangeContainerProps extends RedeemExchangeProps {
  currency?: string;
  exchangeRedeem: typeof exchangeRedeem;
  rewardStoreExchangeRedeem: typeof rewardStoreExchangeRedeem;
  exchanges: ReturnType<typeof getExchanges>;
  getExchangesAction: typeof getExchangesAction;
  selectedExchangeId: ReturnType<typeof getExchangeId>;
  rewardStoreWidgetId?: string;
}

class RedeemExchange extends React.Component<RedeemExchangeContainerProps> {
  render() {
    const { exchanges = [] } = this.props;
    if (exchanges.length === 0) {
      this.props.getExchangesAction();
    }

    const boundRedeem = this.props.rewardStoreWidgetId
      ? (params: ExchangeRedeemParams) =>
          this.props.rewardStoreExchangeRedeem({
            widgetId: this.props.rewardStoreWidgetId!,
            exchangeId: params.exchangeId,
            originalEmail: params.originalEmail,
          })
      : this.props.exchangeRedeem;

    return (
      <RedeemExchangeComponent {...this.props} exchangeRedeem={boundRedeem} />
    );
  }
}

function mapStateToProp(
  state: StoreState,
  props: RedeemExchangeContainerProps
): Pick<
  RedeemExchangeProps,
  | "exchanges"
  | "selectedExchangeId"
  | "isLoadingRedeemExchanges"
  | "originalEmail"
> & { rewardStoreWidgetId?: string } {
  return {
    exchanges: getExchanges(state),
    selectedExchangeId: getExchangeId(state),
    isLoadingRedeemExchanges: state.exchange.isLoadingRedeemExchanges,
    originalEmail:
      get(props, "data.customer.originalEmail") || props.originalEmail,
    rewardStoreWidgetId: get(
      getWidgetConfig(state),
      "settings.rewardStoreWidgetId"
    ) as string | undefined,
  };
}

export default connect(mapStateToProp, {
  exchangeRedeem,
  rewardStoreExchangeRedeem,
  getExchangesAction,
  setScreenName,
})(RedeemExchange);
